import type { Tone } from '@ashniva/ui';

import type { RepositoryStateKind } from './ri-state';

/** Each state's short name, always a word as well as a colour, and its glyph. */
export const STATE_BADGE: Record<RepositoryStateKind, { label: string; tone: Tone; icon: string }> =
  {
    ready: { label: 'Ready', tone: 'success', icon: '✓' },
    stale: { label: 'Outdated', tone: 'warning', icon: '!' },
    indexing: { label: 'Indexing', tone: 'progress', icon: '⧗' },
    pending: { label: 'Waiting for approval', tone: 'info', icon: '⧗' },
    provisioning: { label: 'Being prepared', tone: 'progress', icon: '⧗' },
    'not-registered': { label: 'Not indexed', tone: 'neutral', icon: '○' },
    rejected: { label: 'Rejected', tone: 'danger', icon: '⊘' },
    suspended: { label: 'Suspended', tone: 'danger', icon: '⊘' },
    failed: { label: 'Not available', tone: 'danger', icon: '✕' },
  };
